import {Container, Divider, Text, Title} from '@mantine/core'
import {createFileRoute, redirect} from '@tanstack/react-router'

import {clearCreatedMark, DEFAULT_STORAGE_KEY, quoteDraftKey} from 'src/jobs/create-job-storage'
import {JobEntryPage} from 'src/jobs/job-entry/job-entry-page'

type JobEntrySearch = {
    new?: 1
    quote?: string
}

export const Route = createFileRoute('/_app/jobs/create/')({
    validateSearch: (search: Record<string, unknown>): JobEntrySearch => ({
        new: search['new'] === 1 || search['new'] === '1' ? 1 : undefined,
        quote: typeof search['quote'] === 'string' && search['quote'] ? search['quote'] : undefined,
    }),
    beforeLoad: ({search}) => {
        if (search.new !== 1) {
            return
        }

        clearCreatedMark(search.quote ? quoteDraftKey(search.quote) : DEFAULT_STORAGE_KEY)
        throw redirect({
            to: '/jobs/create',
            search: search.quote ? {quote: search.quote} : {},
            replace: true,
        })
    },
    component: CreateJobRoute,
})

function CreateJobRoute() {
    const {quote} = Route.useSearch()
    return (
        <Container size="lg" py="xl">
            <Title order={1} mb="sm">
                {quote ? 'Create order from quote' : 'Create job'}
            </Title>
            <Text size="md" c="dimmed">
                The order is created when the job is saved.
            </Text>
            <Divider my="md" />
            <JobEntryPage key={quote ?? 'job'} quoteId={quote ?? null} />
        </Container>
    )
}
